import { Component, Vue, Prop as prop, Prop} from 'nuxt-property-decorator';

@Component({
    components: {
      configuratorRow: require('./configurator-row').default
    }
})
export default class RecentViewList extends Vue {

   @Prop() configurator;
   @Prop() selectedOffer: any;
}
